import { useMutation, useQueryClient } from "@tanstack/react-query";

import {
  type GenerateJobClipRequestType,
  type JobScript,
  postProjectsProjectIDJobsJobIDGenerateClip,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import {
  getResourcePath,
  Resources,
} from "Infrastructure/Translations/Resources";
import { PROJECTS_QUERY_KEYS } from "Projects/Api/Queries/queryKeys";

type GenerateClipParams = {
  type: GenerateJobClipRequestType;
  script: JobScript;
};

export function useGenerateClipMutation(projectId: string, jobId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponse(
      ({ type, script }: GenerateClipParams) =>
        postProjectsProjectIDJobsJobIDGenerateClip(
          { script, type },
          projectId,
          jobId,
        ),
      {
        translationPrefix: getResourcePath(Resources.ApiErrors.GenerateJobClip),
      },
    ),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: PROJECTS_QUERY_KEYS.jobDetail(projectId, jobId),
      });
    },
  });
}
